import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory2';

const InventoryCard = () => {
    return (
        <Card
            sx={{
                height: '100%',
                backgroundColor: '#fff',  // white background
                border: 'none',
                borderRadius: 3,
                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.05)',
                border: '1px solid #c8e6c9',
                p: 2,
                transition: 'transform 0.3s ease',
                '&:hover': {
                    transform: 'scale(1.01)',
                    boxShadow: '0 12px 24px rgba(0, 0, 0, 0.1)',
                },
            }}
        >
            <CardContent sx={{ p: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <InventoryIcon sx={{mr: 1 }} />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Inventory Overview
                    </Typography>
                </Box>

                <Typography variant="body2" sx={{ fontSize: '0.95rem' }}>
                    • Total Items: <strong>12,340</strong><br />
                    • Categories: <strong>25</strong><br />
                    • Low Stock Items: <strong>34</strong>
                </Typography>
            </CardContent>
        </Card>
    );
};

export default InventoryCard;